var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31212 13.4999V13.5L8.31992 13.4998L8.33466 13.4996L8.33466 13.4997L8.34161 13.4995C8.62648 13.491 8.89273 13.3629 9.0786 13.1495L14.2443 7.21988C14.2444 7.21987 14.2444 7.21986 14.2444 7.21984C14.614 6.79559 14.5792 6.14784 14.1632 5.76704L14.1631 5.76695C13.7394 5.37935 13.0869 5.41954 12.7115 5.85012L12.7114 5.85025L8.26983 10.9488L6.24932 8.87839C6.24924 8.87831 6.24917 8.87823 6.24909 8.87816C5.84892 8.46783 5.19493 8.46827 4.79507 8.87819C4.40169 9.28136 4.40156 9.93015 4.79517 10.3333L7.58515 13.1924C7.58516 13.1924 7.58517 13.1924 7.58517 13.1924C7.77614 13.3881 8.03745 13.4999 8.31212 13.4999ZM0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V15C17.5 16.3807 16.3807 17.5 15 17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z",
    fill: "#44799C",
    stroke: "#44799C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedFillIcon);
export default __webpack_public_path__ + "static/media/CheckedFillIcon.1e9a8ff1bdc6fa49158ed08e1b3897c3.svg";
export { ForwardRef as ReactComponent };